import { OvertimeComponent } from "../../components";

export default function OvertimeRegistrationPage() {
  return <OvertimeComponent.OvertimeRegistrationList />;
}
